import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=52425c56&scoped=true"
import script from "./date-picker.vue?vue&type=script&lang=js"
export * from "./date-picker.vue?vue&type=script&lang=js"
import style0 from "./date-picker.vue?vue&type=style&index=0&id=52425c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52425c56",
  null
  
)

export default component.exports